import React, { useState } from "react";
import MUIDataTable from "mui-datatables";
import { Tooltip, Modal, Box } from "@mui/material";
import { Add, Done, Error, Refresh } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import PoNewProductForm from "./PoNewProductForm";
import saved from "../../assets/sound/saved.wav";
import { db } from "../../firebase";
import { addDoc, collection } from "firebase/firestore";
import PoRowForm from "./poRowForm";

const PoStore = ({ data, onAdd, onAddRow }) => {
  const [openRow, setOpenRow] = useState(false);
  const [openNew, setOpenNew] = useState(false);

  const [id, SetId] = useState("");
  const [title, setTitle] = useState("");
  const [alterName, setAlterName] = useState("");
  const [barCode, setBarCode] = useState("");
  const [category, setCategory] = useState("");
  const [cost, setCost] = useState("");
  const [price, setPrice] = useState("");
  const [store, setStore] = useState("");
  const [url, SetUrl] = useState("");

  const handleClose = () => {
    setOpenRow(false);
    setOpenNew(false);
  };

  const handleOnSubmit = () => {
    handleNewRecord();
    handleClose();
    new Audio(saved).play();
  };

  const handleOnSubmitRow = () => {
    const product = { 0: id, 1: title, 2: cost, qty: store };
    onAddRow(product);
    setOpenRow(false);
  };

  const handleNewRecord = async () => {
    const ref = collection(db, "products");
    const result = await addDoc(ref, {
      title: title,
      alterName: alterName,
      stock_all: store,
      url_location: url,
      price: price,
      cost: cost,
      category: category,
      barCode: barCode,
      stock_store: store,
      stock_van: 0,
      stock_var1: 0,
      stock_var2: 0,
    });

    const product = { 0: result.id, 1: title, 2: cost, qty: store };
    onAddRow(product);
  };

  const styleMove = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 560,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const ModalFunc = (params) => {
    SetId(params[0]);
    setTitle(params[1]);
    SetUrl(params[4]);
    setPrice(params[2]);
    setCost(params[5]);

    setOpenRow(true);
  };
  const handleRefresh = () => {
    window.location.reload();
  };

  const columns = [
    {
      name: "id", // 0
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "title", // 1
      label: "Title",
    },
    {
      name: "price", // 2
      label: "Price",
      options: {
        display: false,
      },
    },
    {
      name: "stock_all", // 3
      label: "stock",
      options: {
        display: false,
      },
    },
    {
      name: "url_location", // 4
      label: "url",
      options: {
        display: false,
      },
    },
    {
      name: "cost", // 5
      label: "cost",
      options: {
        display: false,
      },
    },
    {
      name: "?",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = tableMeta.rowData;
          const total = Number(row[3]);

          if (total >= 1)
            return (
              <Tooltip title="OK Stock">
                <Done color="primary" />
              </Tooltip>
            );
          else
            return (
              <Tooltip title="Negative Stock">
                <Error color="error" />
              </Tooltip>
            );
        },
      },
    },

    // Add more columns as needed
  ];

  const handleModalAdd = () => {
    setTitle("");
    setAlterName("");
    setStore(0);
    setBarCode("");
    setPrice(0);
    setCost(0);
    SetUrl("");
    setOpenNew(true);
  };

  const AddButton = () => (
    <>
      <Tooltip disableFocusListener title="Create a new product">
        <IconButton onClick={handleModalAdd}>
          <Add />
        </IconButton>
      </Tooltip>
      <Tooltip disableFocusListener title="Refresh DATA">
        <IconButton onClick={handleRefresh}>
          <Refresh />
        </IconButton>
      </Tooltip>
    </>
  );
  const options = {
    customToolbar: AddButton,
    selectableRowsHideCheckboxes: true,
    onRowClick: (rowData) => {
      ModalFunc(rowData);
    },
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  return (
    <>
      {/* =====  NEW REC MODAL ============ */}
      <Modal keepMounted open={openNew} onClose={handleClose}>
        <Box sx={styleMove}>
          <PoNewProductForm
            title={title}
            setTitle={setTitle}
            alterName={alterName}
            setAlterName={setAlterName}
            category={category}
            setCategory={setCategory}
            barCode={barCode}
            setBarCode={setBarCode}
            store={store}
            setStore={setStore}
            price={price}
            setPrice={setPrice}
            cost={cost}
            setCost={setCost}
            url={url}
            SetUrl={SetUrl}
            operation="new"
            handleClose={handleClose}
            textButton="SAVE NEW RECORD"
            handleOnSubmit={handleOnSubmit}
            setOpenNew={setOpenNew}
          />
        </Box>
      </Modal>

      {/* ===== EXIST REC MODAL ============ */}
      <Modal keepMounted open={openRow} onClose={handleClose}>
        <Box sx={styleMove}>
          <PoRowForm
            title={title}
            setTitle={setTitle}
            store={store}
            setStore={setStore}
            price={price}
            setPrice={setPrice}
            cost={cost}
            setCost={setCost}
            url={url}
            SetUrl={SetUrl}
            operation="exist"
            handleClose={handleClose}
            textButton="send tp shopping card"
            handleOnSubmitRow={handleOnSubmitRow}
            setOpenRow={setOpenRow}
          />
        </Box>
      </Modal>

      <MUIDataTable
        title="Purchase Order"
        columns={columns}
        options={options}
        data={data}
      />
    </>
  );
};
export default PoStore;
